// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetItemValue-modulebutton__SxItV";
var _2 = "ProfileInfoWidgetItemValue-modulelink__OrhAr";
var _3 = "ProfileInfoWidgetItemValue-moduletext__QCmBO";
export { _1 as "button", _2 as "link", _3 as "text" }
